export const QUESTION_PLAYER_ERROR_DATA_ATTRIBUTE = 'data-question-player-error';
